export default {"src":"/_next/static/media/blob-1.b921f375.svg","height":278,"width":467,"blurWidth":0,"blurHeight":0};